import React, { useEffect, useState } from "react";
import "./content.css";
import { EyeIcon, PlusIcon, Trash2, Pencil, ArrowRightIcon, ArrowLeftIcon, ChevronRight, ChevronLeft, FilePlus } from "lucide-react";
import AddContentModal from "./AddContentModal";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import Logo from '../../assets/image.png'
import ReactPaginate from "react-paginate";
import ConfirmDelete from "./ConfirmDelete"
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import EditContentModal from "./EditContentModal";
import NoAccessModal from "./NoAccessModal";
import STGLogo from '../../assets/STG_Content.png'
import BOALogo from '../../assets/BOA_Content.png'
import CLUBLogo from '../../assets/CLUB_Content.png'

const Content = () => {
  const userDetails = JSON.parse(localStorage.getItem('userDetails')) || null;
  const [addContentModal, setAddContentModal] = useState(false)
  const [editContentModal, setEditContentModal] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [deleteContent, setDeleteContent] = useState(null);
  const [editContent, setEditContent] = useState(null);
  const [loadingSTG, setLoadingSTG] = useState(true);
  const [loadingBOA, setLoadingBOA] = useState(true);
  const [loadingCLUB, setLoadingCLUB] = useState(true);
  const [noAccessModal, setNoAccessModal] = useState(false);

  const toggleAddContentModal = () => {
    setAddContentModal(!addContentModal)
  }

  const toogleDeleteModal = (content) => {
    setDeleteContent(content);
    setConfirmDelete(!confirmDelete);
  }

  const toogleEditModal = (content) => {
    setEditContent(content);
    setEditContentModal(!editContentModal);
  }

  const [contentSTGData, setContentSTGData] = useState([]);
  const [contentBOAData, setContentBOAData] = useState([]);
  const [contentCLUBData, setContentCLUBData] = useState([]);
  const [contentBOADataLength, setContentBOADataLength] = useState(0);
  const [contentSTGDataLength, setContentSTGDataLength] = useState(0);
  const [contentCLUBDataLength, setContentCLUBDataLength] = useState(0);
  const [refreshGetContentLibrarySTGData, setRefreshGetContentLibrarySTGData] = useState(false)
  const [refreshGetContentLibraryBOAData, setRefreshGetContentLibraryBOAData] = useState(false)
  const [refreshGetContentLibraryCLUBData, setRefreshGetContentLibraryCLUBData] = useState(false)

  const toggleNoAccessModal = () => {
    setNoAccessModal(!noAccessModal);
  }

  const handleVideoUrl = (url, course) => {
    if (userDetails.courses_access[course] != 1 && userDetails.admin != true) {
      toggleNoAccessModal();
      console.error('You don\'t have access to this course');
      return;
    }
    window.open(url, '_blank');
  }

  const getContentLibraryBOAData = async () => {
    try {
      setLoadingBOA(true);
      const response = await apiServiceHandler("GET", `api/content/library/boa?page=${itemOffsetBOA}`, {})
      // console.log(response, 'BOA Response is here...');
      if (response.auth) {
        setContentBOAData(response.contentBOAData);
        setContentBOADataLength(response.totalBOAData);
        setLoadingBOA(false);
        // console.log(contentBOAData, 'data is here')
      }
    } catch (error) {
      console.log('Something went wrong! ', error)
    }
  }

  const getContentLibrarySTGData = async () => {
    try {
      setLoadingSTG(true);
      const response = await apiServiceHandler("GET", `api/content/library/stg90?page=${itemOffsetSTG}`, {})
      // console.log(response, 'STG Response is here...');
      if (response.auth) {
        setContentSTGData(response.contentSTGData);
        setContentSTGDataLength(response.totalSTGData);
        setLoadingSTG(false);
      }
    } catch (error) {
      console.log('Something went wrong! ', error)
    }
  }

  const getContentLibraryCLUBData = async () => {
    try {
      setLoadingCLUB(true);
      const response = await apiServiceHandler("GET", `api/content/library/club84?page=${itemOffsetCLUB}`, {})
      console.log(response, 'CLUB Response is here...');
      if (response.auth) {
        setContentCLUBData(response.contentCLUBData);
        setContentCLUBDataLength(response.totalCLUBData);
        setLoadingCLUB(false);
      }
    } catch (error) {
      console.log('Something went wrong! ', error)
    }
  }

  const itemsPerPageSTG = 4;
  const itemsPerPageBOA = 4;
  const itemsPerPageCLUB = 4;

  const [itemOffsetSTG, setItemOffsetSTG] = useState(0);
  const [itemOffsetBOA, setItemOffsetBOA] = useState(0);
  const [itemOffsetCLUB, setItemOffsetCLUB] = useState(0);

  const pageCountSTG = Math.ceil(contentSTGDataLength / itemsPerPageSTG);
  const pageCountBOA = Math.ceil(contentBOADataLength / itemsPerPageBOA);
  const pageCountCLUB = Math.ceil(contentCLUBDataLength / itemsPerPageCLUB);

  const handlePageClickSTG = (event) => {
    // const newOffsetSTG = (event.selected * itemsPerPageSTG) % contentSTGData?.length;
    console.log(event.selected, 'selected is here...')
    setItemOffsetSTG(event.selected);
  };

  const handlePageClickBOA = (event) => {
    // const newOffsetBOA = (event.selected * itemsPerPageBOA) % contentBOAData?.length;
    setItemOffsetBOA(event.selected);
  };

  const handlePageClickCLUB = (event) => {
    setItemOffsetCLUB(event.selected);
  };

  const updatePaginationOnDelete = () => {
    if (contentSTGData.length == 1 && itemOffsetSTG >= 1) {
      setItemOffsetSTG(itemOffsetSTG - 1);
      setRefreshGetContentLibrarySTGData(true);
    }
    if (contentBOAData.length == 1 && itemOffsetBOA >= 1) {
      setItemOffsetBOA(itemOffsetBOA - 1);
      setRefreshGetContentLibraryBOAData(true);
    }
    if (contentCLUBData.length == 1 && itemOffsetCLUB >= 1) {
      setItemOffsetCLUB(itemOffsetCLUB - 1);
      setRefreshGetContentLibraryCLUBData(true);
    }
  };

  useEffect(() => {
    getContentLibraryBOAData();
    setRefreshGetContentLibraryBOAData(false);
  }, [itemOffsetBOA, refreshGetContentLibraryBOAData])

  useEffect(() => {
    getContentLibrarySTGData();
    setRefreshGetContentLibrarySTGData(false);
  }, [itemOffsetSTG, refreshGetContentLibrarySTGData])

  useEffect(() => {
    getContentLibraryCLUBData();
    setRefreshGetContentLibraryCLUBData(false);
  }, [itemOffsetCLUB, refreshGetContentLibraryCLUBData])

  return (
    <div className="">
      <div className="library-page-content">
        <div className="library-page-section">
          {/* page header */}
          <div className="library-page-section-header">
            <div className="library-page-header">
              <div className="library-page-header__eyebrow">
                All your content in one place
              </div>
              <div className="library-page-header__top">
                <div className="library-page-header-content">
                  <div className="library-page-heading">Content Library</div>
                  {/*
                  <div className="library-page-text-input">
                    <div className="library-page-text-input__wrapper">
                      <input
                        type="text"
                        placeholder="search content..."
                        className="text-input__input"
                      />
                      <SearchIcon
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  </div>
                  */}
                  {userDetails && userDetails.admin &&
                    <button className="add-content-btn" onClick={toggleAddContentModal}>
                      {/* 
                      <span class="icon-plus">
                        <FilePlus />
                      </span>
                      */}
                      <span class="add-content-btn-label">Add Content</span>
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>

          {/* page body */}
          {contentSTGData.length > 0 && <div className="library-page-section-body">
            <div className="library-page-section-body-header">
              <div className="section-body-header-content">
                <div className="heading--4">STG Community Calls</div>
                {/*
                <div className="heading--8">
                  This section lists all the content that the coach has added as
                  PBA.
                </div>
                */}
              </div>
            </div>
            {loadingSTG ? (<SkeletonTheme baseColor="#f4f7f8" highlightColor="#e2e8f0">
              <p>
                <Skeleton
                  count={4}
                  duration={2}
                  enableAnimation
                  height={20}
                  inline={true}
                />
              </p>
            </SkeletonTheme>) : (<div>
              {contentSTGData.map((content, index) => (<div className="data-table">
                <div className="data-table__table" key={index}>
                  <div className="data-table-body">
                    <div className="data-table-row">
                      <div className="data-table__cell--name">
                        <div className="data-table__cell-body">
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {/*
                            <div className="image-preview">
                              <img
                                src={content.thumbnail ? content.thumbnail : STGLogo}
                                alt="Thumbnail"
                                style={
                                  !content.thumbnail
                                    ? { transform: 'scale(2) translateX(6px) translateY(1px)', objectFit: 'cover', width: '56px' }
                                    : {}
                                }
                              />
                            </div>
                            */}
                            <span className="label-item" onClick={() => handleVideoUrl(content.recording_url, 'stg90')}>
                              {content.title}
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* 
                      <div class="data-table__cell--assigned">
                        <div class="data-table__cell-body">
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ cursor: 'pointer' }}>in 1 step</span>
                          </div>
                        </div>
                      </div>
                      */}
                      <div className="data-table__cell--actions">
                        <div className="data-table__cell-body">
                          <div className="actions-column">
                            <button className="details-button" onClick={() => handleVideoUrl(content.recording_url, 'stg90')}>
                              <span className="icon--eye">
                                <EyeIcon
                                  color="#d1b794"
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    cursor: "pointer",
                                  }}
                                />
                              </span>
                            </button>
                            {userDetails && userDetails.admin &&
                              <button className="edit-button" onClick={() => toogleEditModal(content)}>
                                <span className="icon--eye">
                                  <Pencil
                                    color="#604b51"
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              </button>
                            }
                            {userDetails && userDetails.admin &&
                              <button className="delete-button" onClick={() => toogleDeleteModal(content)}>
                                <span className="icon--eye">
                                  <Trash2
                                    color="#EE4B2B"
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>))}
            </div>)}
            <div
              style={loadingSTG ? { display: 'none' } : {
                display: "flex",
                justifyContent: "center",
                padding: 0,
                width: "100%",
                alignItems: 'center'
              }}
            >
              <ReactPaginate
                containerClassName={"pagination"}
                pageClassName={"user-page-item"}
                activeClassName={"user-active"}
                onPageChange={handlePageClickSTG}
                pageCount={pageCountSTG}
                nextLabel={
                  pageCountSTG > 1 ? <ChevronRight className="pagination-btn" size={40}
                    style={{
                      fontSize: 16,
                      width: 150,
                      height: 25,
                      color: "#604b51",
                      background: "#d1b794",
                      borderRadius: "50px",
                      width: "fit-content",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  /> : null
                }
                previousLabel={
                  pageCountSTG > 1 ? <ChevronLeft className="pagination-btn" size={40}
                    style={{
                      fontSize: 16,
                      width: 150,
                      height: 25,
                      color: "#604b51",
                      background: "#d1b794",
                      borderRadius: "50px",
                      width: "fit-content",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  /> : null
                }
              />
            </div>
          </div>}

          {/* page body */}
          {contentBOAData.length > 0 && <div className="library-page-section-body">
            <div className="library-page-section-body-header">
              <div className="section-body-header-content">
                <div className="heading--4">The Foundation Lab™</div>
                {/* 
                <div className="heading--8">
                  This section lists all the content that the coach has added as
                  BOA.
                </div>
                */}
              </div>
            </div>
            {loadingBOA ? ((<SkeletonTheme baseColor="#f4f7f8" highlightColor="#e2e8f0">
              <p>
                <Skeleton
                  count={4}
                  duration={2}
                  enableAnimation
                  height={20}
                  inline={true}
                />
              </p>
            </SkeletonTheme>)) : (<div>
              {contentBOAData.map((content, index) => (<div className="data-table">
                <div className="data-table__table" key={index}>
                  <div className="data-table-body">
                    <div className="data-table-row">
                      <div className="data-table__cell--name">
                        <div className="data-table__cell-body">
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {/*
                            <div className="image-preview">
                              <img
                                src={content.thumbnail ? content.thumbnail : BOALogo}
                                alt="Thumbnail"
                                style={
                                  !content.thumbnail
                                    ? { objectFit: 'cover' }
                                    : {}
                                }
                              />
                            </div>
                            */}
                            <span className="label-item" onClick={() => handleVideoUrl(content.recording_url, 'boa')}>
                              {content.title}
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* 
                      <div class="data-table__cell--assigned">
                        <div class="data-table__cell-body">
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ cursor: 'pointer' }}>in 1 step</span>
                          </div>
                        </div>
                      </div>
                      */}
                      <div className="data-table__cell--actions">
                        <div className="data-table__cell-body">
                          <div className="actions-column">
                            <button className="details-button" onClick={() => handleVideoUrl(content.recording_url, 'boa')}>
                              <span className="icon--eye">
                                <EyeIcon
                                  color="#d1b794"
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    cursor: "pointer",
                                  }}
                                />
                              </span>
                            </button>
                            {userDetails && userDetails.admin &&
                              <button className="edit-button" onClick={() => toogleEditModal(content)}>
                                <span className="icon--eye">
                                  <Pencil
                                    color="#604b51"
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              </button>
                            }
                            {userDetails && userDetails.admin &&
                              <button className="delete-button" onClick={() => toogleDeleteModal(content)}>
                                <span className="icon--eye">
                                  <Trash2
                                    color="#EE4B2B"
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>))}
            </div>)}
            <div
              style={loadingBOA ? { display: 'none' } : {
                display: "flex",
                justifyContent: "center",
                padding: 0,
                width: "100%",
                alignItems: 'center'
              }}
            >
              <ReactPaginate
                containerClassName={"pagination"}
                pageClassName={"user-page-item"}
                activeClassName={"user-active"}
                onPageChange={handlePageClickBOA}
                pageCount={pageCountBOA}
                nextLabel={
                  pageCountBOA > 1 ? <ChevronRight className="pagination-btn" size={40}
                    style={{
                      fontSize: 16,
                      width: 150,
                      height: 25,
                      color: "#604b51",
                      background: "#d1b794",
                      borderRadius: "50px",
                      width: "fit-content",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  /> : null
                }
                previousLabel={
                  pageCountBOA > 1 ? <ChevronLeft className="pagination-btn" size={40}
                    style={{
                      fontSize: 16,
                      width: 150,
                      height: 25,
                      color: "#604b51",
                      background: "#d1b794",
                      borderRadius: "50px",
                      width: "fit-content",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  /> : null
                }
              />
            </div>
          </div>}

          {/* page body */}
          {contentCLUBData.length > 0 && <div className="library-page-section-body">
            <div className="library-page-section-body-header">
              <div className="section-body-header-content">
                <div className="heading--4">Creative CEO Accelerator™</div>
                {/* 
                <div className="heading--8">
                  This section lists all the content that the coach has added as
                  BOA.
                </div>
                */}
              </div>
            </div>
            {loadingCLUB ? ((<SkeletonTheme baseColor="#f4f7f8" highlightColor="#e2e8f0">
              <p>
                <Skeleton
                  count={4}
                  duration={2}
                  enableAnimation
                  height={20}
                  inline={true}
                />
              </p>
            </SkeletonTheme>)) : (<div>
              {contentCLUBData.map((content, index) => (<div className="data-table">
                <div className="data-table__table" key={index}>
                  <div className="data-table-body">
                    <div className="data-table-row">
                      <div className="data-table__cell--name">
                        <div className="data-table__cell-body">
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {/*
                            <div className="image-preview">
                              <img
                                src={content.thumbnail ? content.thumbnail : CLUBLogo}
                                alt="Thumbnail"
                                style={
                                  !content.thumbnail
                                    ? { transform: 'scale(1.9) translateX(4px) translateY(4px)', objectFit: 'cover', width: '56px' }
                                    : {}
                                }
                              />
                            </div>
                            */}
                            <span className="label-item" onClick={() => handleVideoUrl(content.recording_url, 'club84')}>
                              {content.title}
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* 
                      <div class="data-table__cell--assigned">
                        <div class="data-table__cell-body">
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ cursor: 'pointer' }}>in 1 step</span>
                          </div>
                        </div>
                      </div>
                      */}
                      <div className="data-table__cell--actions">
                        <div className="data-table__cell-body">
                          <div className="actions-column">
                            <button className="details-button" onClick={() => handleVideoUrl(content.recording_url, 'club84')}>
                              <span className="icon--eye">
                                <EyeIcon
                                  color="#d1b794"
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    cursor: "pointer",
                                  }}
                                />
                              </span>
                            </button>
                            {userDetails && userDetails.admin &&
                              <button className="edit-button" onClick={() => toogleEditModal(content)}>
                                <span className="icon--eye">
                                  <Pencil
                                    color="#604b51"
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              </button>
                            }
                            {userDetails && userDetails.admin &&
                              <button className="delete-button" onClick={() => toogleDeleteModal(content)}>
                                <span className="icon--eye">
                                  <Trash2
                                    color="#EE4B2B"
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>))}
            </div>)}
            <div
              style={loadingCLUB ? { display: 'none' } : {
                display: "flex",
                justifyContent: "center",
                padding: 0,
                width: "100%",
                alignItems: 'center'
              }}
            >
              <ReactPaginate
                containerClassName={"pagination"}
                pageClassName={"user-page-item"}
                activeClassName={"user-active"}
                onPageChange={handlePageClickCLUB}
                pageCount={pageCountCLUB}
                nextLabel={
                  pageCountCLUB > 1 ? <ChevronRight className="pagination-btn" size={40}
                    style={{
                      fontSize: 16,
                      width: 150,
                      height: 25,
                      color: "#604b51",
                      background: "#d1b794",
                      borderRadius: "50px",
                      width: "fit-content",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  /> : null
                }
                previousLabel={
                  pageCountCLUB > 1 ? <ChevronLeft className="pagination-btn" size={40}
                    style={{
                      fontSize: 16,
                      width: 150,
                      height: 25,
                      color: "#604b51",
                      background: "#d1b794",
                      borderRadius: "50px",
                      width: "fit-content",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  /> : null
                }
              />
            </div>
          </div>}
        </div>
      </div>
      <ConfirmDelete isOpen={confirmDelete} onClose={toogleDeleteModal} deleteContent={deleteContent} setRefreshGetContentLibrarySTGData={setRefreshGetContentLibrarySTGData} setRefreshGetContentLibraryBOAData={setRefreshGetContentLibraryBOAData} setRefreshGetContentLibraryCLUBData={setRefreshGetContentLibraryCLUBData} updatePaginationOnDelete={updatePaginationOnDelete} />
      <AddContentModal isOpen={addContentModal} onClose={toggleAddContentModal} setRefreshGetContentLibrarySTGData={setRefreshGetContentLibrarySTGData} setRefreshGetContentLibraryBOAData={setRefreshGetContentLibraryBOAData} setRefreshGetContentLibraryCLUBData={setRefreshGetContentLibraryCLUBData} />
      <EditContentModal isOpen={editContentModal} onClose={toogleEditModal} contentData={editContent} setRefreshGetContentLibrarySTGData={setRefreshGetContentLibrarySTGData} setRefreshGetContentLibraryBOAData={setRefreshGetContentLibraryBOAData} setRefreshGetContentLibraryCLUBData={setRefreshGetContentLibraryCLUBData} />
      <NoAccessModal isOpen={noAccessModal} onClose={toggleNoAccessModal} />
    </div>
  );
};

export default Content;
